import { Component, OnInit, NgModule } from '@angular/core';
import { CacheService } from '../../../infrastructure/services/cache.service';
import { ErrorMessageService } from 'app/infrastructure/services/error.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html'
})
export class ErrorComponent implements OnInit {

  messages: string[];


  constructor(
    private cacheService: CacheService,
    private errorMessageService: ErrorMessageService,
  ) {}

  ngOnInit(): void {
   this.messages = (this.errorMessageService.getError());
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/public/error/error/error.component.ts